import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';

class CheckBoxField extends Component {
    render() {
        const { isChecked, onChangeHandler, name, id, text = null } = this.props;
        return <label className="form-check p-0 d-flex align-items-center m-0" htmlFor={id}>
        <input type="checkbox" id={id} className="form-check-input me-2" name={name} checked={isChecked} onChange={onChangeHandler} /><span></span>
         { text ? text : text!=0 ? 'Manually approve posts before making them public?' : <></> }
        </label>
    }
}

export default CheckBoxField;